import { useEffect, useRef } from 'react';
import { routeIds } from '../i18n/routes';
import { useI18n } from '../i18n/I18nContext';
import LanguageMenu from './LanguageMenu';

function Option({ href, content, selected, onClick }) {
  const font = selected ? "font-bold" : "font-medium";
  return (
    <li><a className={`text-white text-lg ${font} lowercase transition duration-300 hover:opacity-50`} href={href} onClick={onClick}>{content}</a></li>
  );
}

function Drawer({route}) {
  const state = route.drawer;
  const visible = state[0];
  const setVisible = state[1];
  const { pathFor, t } = useI18n();
  const drawerRef = useRef(null);

  useEffect(() => {
    if (!visible) return;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    const drawer = drawerRef.current;
    drawer.querySelector('button').focus();
    document.body.style.overflow = 'hidden';
    const desktop = window.matchMedia('(min-width: 1024px)');
    const closeOnDesktop = () => { if (desktop.matches) setVisible(false); };
    const onKeyDown = event => {
      if (event.key === 'Escape') setVisible(false);
      if (event.key !== 'Tab') return;
      const items = [...drawer.querySelectorAll('a[href], button')];
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    drawer.addEventListener('keydown', onKeyDown);
    desktop.addEventListener('change', closeOnDesktop);
    return () => {
      document.body.style.overflow = previousOverflow;
      drawer.removeEventListener('keydown', onKeyDown);
      desktop.removeEventListener('change', closeOnDesktop);
      previousFocus?.focus();
    };
  }, [visible, setVisible]);

  const closeSelf = () => setVisible(false);
  const path = route.status < 400 ? route.path : "/not-found";

  return (
    <div
      ref={drawerRef}
      id="navigation-drawer"
      role="dialog"
      aria-label={t('navigation.openMenu')}
      aria-modal={visible ? true : undefined}
      aria-hidden={!visible}
      inert={!visible}
      className={`site-drawer fixed right-0 top-0 px-10 py-[1.5625rem] h-[100dvh] max-w-full overflow-y-auto bg-primary-300 drop-shadow-lg lg:hidden z-50 transform transition-transform duration-300 ${
        visible ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <ul className="flex flex-col space-y-5">
        <li className="ml-auto">
          <button type="button" aria-label={t('navigation.closeMenu')} className="text-white font-bold text-4xl transition duration-300 hover:opacity-50" onClick={closeSelf}>
            ✕
          </button>
        </li>
        <Option href={pathFor(routeIds.expertise)} content={t("navigation.expertise")} selected={path.startsWith("/expertises")} onClick={closeSelf} />
        <Option href={pathFor(routeIds.projects)} content={t("navigation.projects")} selected={path.startsWith("/realisations")} onClick={closeSelf} />
        <Option href={pathFor(routeIds.team)} content={t("navigation.team")} selected={path.startsWith("/equipe")} onClick={closeSelf} />
        <Option href={pathFor(routeIds.contact)} content={t("navigation.contact")} selected={path.startsWith("/contact")} onClick={closeSelf} />
        <li className="pt-2">
          <LanguageMenu variant="dark" compact onSelect={closeSelf} />
        </li>
      </ul>
    </div>
  );
}

export default Drawer;
